import { createContext, useContext } from 'react';

export const QualityDetailContext = createContext(undefined);

export const useQualityDetailContext = () => {
  const cxt = useContext(QualityDetailContext);

  if (!cxt) throw new Error('useQualityDetailContext must be used with provider');

  return cxt;
};

export const QualityProgressionContext = createContext(undefined);

export const useQualityProgressionContext = () => {
  const cxt = useContext(QualityProgressionContext);

  if (!cxt)
    throw new Error('QualityProgressionContext must be used with provider');

  return cxt;
};
